import { createAction } from '@lingoda/core';

export default createAction('analytics/UPDATE_GTM_USER_DATA');
